import styled from "styled-components";
import nbrTan from "./NbrTan.png"

const Img = styled.img`
  margin-top: 14px;
  margin-bottom: 14px;
  width: 73.61px;
  height: 104.07px;
  flex-grow: 0;
  object-fit: contain;

`

export default () => (
  <Img src={"/rtan_card_in_hand.png"} alt={"르탄이"}/>
)
